<div class="container">

  <div class="header">
    <h2>Ingrese su nueva contraseña</h2>
    <div *ngIf="mensaje" class="mensaje">
      <span >{{ mensaje }}</span>
    </div>
  </div>
  <div fxLayout="column" fxLayoutGap="30px">

    <mat-form-field appearance="outline" [formGroup]="form">
      <mat-label>Contraseña actual</mat-label>
      <input formControlName="claveActual" matInput [type]="hideCurrent ? 'password' : 'text'">
      <button mat-icon-button matSuffix (click)="hideCurrent = !hideCurrent" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hideCurrent">
        <mat-icon>{{hideCurrent ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-error>
        <div *ngFor="let e of errorsMsg">
          <span *ngIf="form.get('claveActual').hasError(e.type) && (form.get('claveActual').dirty || form.get('claveActual').touched)">
            {{ e.message }}
          </span>
        </div>
      </mat-error>

    </mat-form-field>

    <mat-form-field appearance="outline" [formGroup]="repForm">
      <mat-label>Nueva contraseña</mat-label>
      <input #new formControlName="claveNueva" matInput [type]="hideNew ? 'password' : 'text'">
      <button mat-icon-button matSuffix (click)="hideNew = !hideNew" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hideNew">
        <mat-icon>{{hideNew ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-error>
        <div *ngFor="let e of errorsMsg">
          <span *ngIf="repForm.get('claveNueva').hasError(e.type) && (repForm.get('claveNueva').dirty || repForm.get('claveNueva').touched)">
            {{ e.message }}
          </span>
        </div>
      </mat-error>

    </mat-form-field>

    <mat-form-field appearance="outline" [formGroup]="repForm">
      <mat-label>Repetir nueva contraseña</mat-label>
      <input #rep formControlName="repetirClave" matInput [type]="hideRepeat ? 'password' : 'text'">
      <button mat-icon-button matSuffix (click)="hideRepeat = !hideRepeat" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hideRepeat">
        <mat-icon>{{hideRepeat ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-error>
        <div *ngFor="let e of errorsRepMsg">
          <span *ngIf="(repForm.get('repetirClave').hasError(e.type) || repForm.hasError(e.type)) && (repForm.get('repetirClave').dirty || repForm.get('repetirClave').touched)">
            {{ e.message }}
          </span>
        </div>
      </mat-error>

    </mat-form-field>

  </div>
  <br><br>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
    <button mat-raised-button class="accept-button"  color="primary" (click)="sendForm()" [ngClass]="{
      'accept-submit-disable': inSubmission,
      'spinner-accept': inSubmission
  }" [disabled]="inSubmission">
      <div class="icon-text">
        Aceptar
      </div>
    </button>
    <button mat-raised-button color="danger" mat-dialog-close>Cancelar</button>
  </div>

</div>
